import { Component, OnInit } from '@angular/core';
import { CommonsService } from 'src/app/services/commons.service';
declare var document: any;
declare var $: any;
@Component({
  standalone: false,
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {

  kpis: any;
  balance: any;
  data = [];
  count = 0;
  numberPoints = [];
  score: string;
  constructor(private c: CommonsService) { }

  ngOnInit() {
    // this.kpis = this.getData();
    // this.balance = this.kpis.score.Balance;
    // this.score = this.kpis.score.ScoreNumber;
    // this.get4Kpis();
    // this.generateMoveLateralCursor();
    // this.generateMoveLateralTouchEvent();
  }

  getData() {
    let d = sessionStorage.getItem('_k') ? this.c.decrypt(sessionStorage.getItem('_k')) : this.c.getKpi();
    if (d.score) {
      d = (this.c.getKpi() && this.c.getKpi().kpis.length) ? this.c.getKpi() : this.c.decrypt(sessionStorage.getItem('_k'));
    } else {
      d = (this.c.getKpi() && this.c.getKpi().Scores[0].length) ? this.c.getKpi() : this.c.decrypt(sessionStorage.getItem('_k'));
    }
    return d;
  }


  /**
   * clasifica por numero par e inpar y asigna una clase
   * @param num: numero
   */
  selectClass(num) {
    if (num % 2 === 0) {
      return 'par';
    } else {
      return 'inpar';
    }
  }

  /**
   * elimina espacios en blanco
   * @param str: string
   */
  withOuthSpace(str: string) {
    return str.replace(' ', '');
  }

  flipMethod(id, flip) {
    if (flip) {
      document.querySelector('#' + id).style.transform = 'rotateY(180deg)';
    } else {
      document.querySelector('#' + id).style.transform = 'rotateY(0deg)';
    }
  }

  /**
   * acorta una cuenta
   * @param str:string
   */
  shortAccount(str: string) {
    const l = str.length;
    return str.substring(l - 4, l);
  }

  generateMoveLateralTouchEvent() {
    const slider = document.querySelector('.move-lateral');
    let isDown = false;
    let startX;
    let scrollLeft;
    slider.addEventListener('touchend', (e) => {
      isDown = true;
    });

    slider.addEventListener('touchstart', (e) => {
      isDown = false;
      startX = e.changedTouches[0].screenX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('touchmove', (e) => {
      if (isDown) {
        return;
      }
      e.preventDefault();
      const x = e.changedTouches[0].screenX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  }

  /**
   * genera efecto de movimiento lateral con cursor
   */
  generateMoveLateralCursor() {
    const slider = document.querySelector('.move-lateral');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener('mouseleave', () => { isDown = false; });
    slider.addEventListener('mouseup', () => { isDown = false; });
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) {
        return;
      }
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;

      slider.scrollLeft = scrollLeft - walk;
    });
  }

  private get4Kpis() {
    const n = this.kpis.kpis.length;
    const par = n % 4 === 0;
    // genera id por cada kpi que existe
    for (let i = 0; i < n; i++) {
      this.kpis.kpis[i].id = i + 1;
    }
    if (par) {
      for (let i = 0; i < (n / 4); i++) {
        this.numberPoints.push(i + 1);
        this.data.push({ group: this.kpis.kpis.splice(0, 4) });
      }
    } else {
      const num = Math.floor(n / 4) + 1;
      for (let i = 0; i < num; i++) {
        this.numberPoints.push(i + 1);
        this.data.push({ group: this.kpis.kpis.splice(0, 4) });
      }
    }
  }
}
